import React from 'react';
import NFTCard from './NFTCard';

export default function NFTGrid({ nfts, onSelect }) {
  return (
    <div className="nft-grid">
      {nfts.map(n => <NFTCard key={n.id} nft={n} onClick={() => onSelect && onSelect(n)} />)}
    </div>
  );
}
